import React from "react"

const Avatar = ({
  name,
  size = "medium",
  backgroundColor,
  textColor = "white"
}) => {
  // Generate initials from name
  const getInitials = fullName => {
    if (!fullName || fullName.trim() === "") return "?"

    const words = fullName
      .trim()
      .split(" ")
      .filter(word => word.length > 0)

    if (words.length === 1) {
      // Single word - take first two characters
      return words[0].substring(0, 2).toUpperCase()
    } else {
      // Multiple words - take first character of each word
      return words
        .map(word => word.charAt(0))
        .join("")
        .substring(0, 2)
        .toUpperCase()
    }
  }

  // Generate background color if not provided
  const getBackgroundColor = name => {
    if (backgroundColor) return backgroundColor

    // Generate consistent color based on name
    const colors = [
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#96CEB4",
      "#FFEAA7",
      "#DDA0DD",
      "#98D8C8",
      "#F7DC6F",
      "#BB8FCE",
      "#85C1E9",
      "#F8C471",
      "#82E0AA",
      "#F1948A",
      "#85C1E9",
      "#D7BDE2"
    ]

    let hash = 0
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }

    return colors[Math.abs(hash) % colors.length]
  }

  // Size configurations
  const sizeConfig = {
    small: { width: "24px", height: "24px", fontSize: "10px" },
    medium: { width: "32px", height: "32px", fontSize: "12px" },
    large: { width: "40px", height: "40px", fontSize: "14px" }
  }

  const config = sizeConfig[size]
  const initials = getInitials(name)
  const bgColor = getBackgroundColor(name)

  return (
    <div
      style={{
        width: config.width,
        height: config.height,
        borderRadius: "50%",
        backgroundColor: bgColor,
        color: textColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: config.fontSize,
        fontWeight: "600",
        fontFamily: "system-ui, -apple-system, sans-serif",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        flexShrink: 0
      }}
      title={name}
    >
      {initials}
    </div>
  )
}

export default Avatar
